export type LanguageCode = 'en' | 'nl' | 'fr' | 'de';

type Language = {
	code: LanguageCode;
	file: string;
};

const languages: Language[] = [
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'fr',
		file: 'fr.ts',
	},
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'de',
		file: 'de.ts',
	},
];

export default languages;
